let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6QXwh")).then(() => parcelRequire('bg3kq'));